/* SR-012: PDP gallery behaviour — hardcode of the Intelligems SR-012 win.

   The USP hero slide and ProFlex slide cull are rendered server-side in
   snippets/A-product-media-gallery.liquid, and the theme's native Swiper
   already handles the variant->image swap plus thumbnail click + active class.

   So this file adds ONLY the three behaviours the theme lacks under the SR-012
   layout:
     1. hover prev/next arrows on the main hero (desktop; CSS hides on mobile)
     2. forward image-body clicks to the theme's zoom/lightbox anchor, which the
        theme otherwise only triggers from a tiny corner icon that is
        display:none on mobile/tablet (Clarity showed rage-clicking the image)
     3. keep the active thumbnail scrolled into view — the SR-012 CSS turns the
        theme's vertical Swiper rail into a horizontal overflow strip
        (transform:none), which disables Swiper's own centering.

   Loaded only on SR-012 PDPs via sections/A-main-product.liquid. No hero swap,
   flicker guard, Clarity tagging or polling re-runs — those existed in Jono's
   Intelligems version only because it was an external injection. */
(function () {
  'use strict';

  var THUMB_GAP = 10; // px, matches the CSS gap on the thumb strip

  function mainEl() { return document.querySelector('.l-product-media__main'); }
  function thumbsEl() { return document.querySelector('.l-product-media__thumbnails'); }

  function bindArrows(el) {
    if (!el || el.querySelector('.sr012-arrow.left')) return; // already bound
    ['left', 'right'].forEach(function (side) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'sr012-arrow ' + side;
      btn.setAttribute('aria-label', side === 'left' ? 'Previous image' : 'Next image');
      var d = side === 'left' ? 'M15 6l-6 6 6 6' : 'M9 6l6 6-6 6';
      btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="' + d + '"/></svg>';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (!el.swiper) return;
        if (side === 'left') el.swiper.slidePrev();
        else el.swiper.slideNext();
      });
      el.appendChild(btn);
    });
  }

  function bindImageZoom(el) {
    if (!el) return;
    var slides = el.querySelectorAll('.swiper-slide');
    for (var i = 0; i < slides.length; i++) {
      var img = slides[i].querySelector('.l-product-media__main-image') || slides[i].querySelector('img');
      var zoom = slides[i].querySelector('.l-product-media__main-zoom');
      if (!img || !zoom || img.__sr012zoom) continue;
      img.__sr012zoom = true;
      img.style.cursor = 'zoom-in';
      (function (z) {
        img.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          z.click(); // fires the theme's PhotoSwipe/lightbox, works on mobile too
        });
      })(zoom);
    }
  }

  function centerActiveThumb(mEl, tEl) {
    if (!mEl || !mEl.swiper || !tEl) return;
    var wrap = tEl.querySelector('.swiper-wrapper');
    if (!wrap) return;
    var slides = [].slice.call(tEl.querySelectorAll('.swiper-slide'));
    var active = slides[mEl.swiper.activeIndex]; // thumbs are index-aligned with main (USP at 0)
    if (!active) return;
    var w = active.getBoundingClientRect().width;
    // Keep the active thumb one slot in from the left where possible.
    var target = Math.max(0, (mEl.swiper.activeIndex - 1) * (w + THUMB_GAP));
    wrap.scrollLeft = target;
  }

  // ADA (axe scrollable-region-focusable, serious): the SR-012 CSS makes the thumb
  // strip a horizontal overflow region with nothing focusable inside it, so a
  // keyboard user could neither reach it nor pick a thumbnail. Each thumb becomes a
  // real keyboard control (Enter/Space) that drives the main gallery, and the one
  // showing is exposed with aria-current.
  function bindThumbKeys(mEl, tEl) {
    var slides = [].slice.call(tEl.querySelectorAll('.swiper-slide'));
    slides.forEach(function (slide, i) {
      if (slide.__sr012key) return;
      slide.__sr012key = true;
      slide.setAttribute('tabindex', '0');
      slide.setAttribute('role', 'button');
      slide.setAttribute('aria-label', 'Show image ' + (i + 1) + ' of ' + slides.length);
      slide.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        e.preventDefault();
        if (mEl.swiper) mEl.swiper.slideTo(i); // thumbs are index-aligned with main
      });
    });
  }

  function markCurrentThumb(mEl, tEl) {
    if (!mEl || !mEl.swiper || !tEl) return;
    var slides = tEl.querySelectorAll('.swiper-slide');
    for (var i = 0; i < slides.length; i++) {
      if (i === mEl.swiper.activeIndex) slides[i].setAttribute('aria-current', 'true');
      else slides[i].removeAttribute('aria-current');
    }
  }

  function init() {
    var mEl = mainEl();
    if (!mEl || !mEl.swiper) return false;
    var tEl = thumbsEl();

    bindArrows(mEl);
    bindImageZoom(mEl);

    // Flag the Swiper instance (not the element) so that if the theme ever
    // rebuilds the swiper we rebind to the new instance rather than skip.
    if (tEl && !mEl.swiper.__sr012thumb) {
      mEl.swiper.__sr012thumb = true;
      bindThumbKeys(mEl, tEl);
      mEl.swiper.on('slideChange', function () {
        centerActiveThumb(mEl, tEl);
        markCurrentThumb(mEl, tEl);
      });
      centerActiveThumb(mEl, tEl);
      markCurrentThumb(mEl, tEl);
    }
    return true;
  }

  if (!init()) {
    var n = 0;
    var poll = setInterval(function () {
      if (init() || ++n > 40) clearInterval(poll); // ~8s max, gates on Swiper ready
    }, 200);
  }
})();
